<template>
    <main id="mainCtrl" v-cloak>
        <DirectQuestionAnswersDialog ref="directQuestionAnswersDialog" />
        <v-table id="table"
                 request-uri="directQuestions/getList"
                 pagesize="50"
                 :show-eye="false"
                 ref="table">
            <template v-slot:header>
                <v-tr>
                    <v-th name="created_at" sort="created_at" width="85">
                        Создан
                    </v-th>
                    <v-th name="ratingCommentLast" sort="ratingCommentLast" width="85">
                        Ответ
                    </v-th>
                    <v-th name="intervieweeName" width="120">
                        Кому
                    </v-th>
                    <v-th name="author_name" sort="author_name" width="130">
                        Автор
                    </v-th>
                    <v-th name="info">
                       Отзыв
                    </v-th>
                    <v-th name="hasComments" width="70">
                        Ответ
                    </v-th>
                </v-tr>
                <v-tr>
                    <v-th name="created_at" v-slot="{filter}" width="85">
                        <date-picker v-model="filter.value"/>
                    </v-th>
                    <v-th name="ratingCommentLast" v-slot="{filter}" width="85">
                        <date-picker v-model="filter.value"/>
                    </v-th>
                    <v-th name="intervieweeName" v-slot="{filter}" width="120">
                        <v-input v-model="filter.value"/>
                    </v-th>
                    <v-th name="author_name" v-slot="{filter}" width="130">
                        <v-input v-model="filter.value"/>
                    </v-th>
                    <v-th name="info" v-slot="{filter}">
                        <v-input v-model="filter.value"/>
                    </v-th>
                    <v-th name="hasComments"  v-slot="{filter}">
                        <v-select
                            v-model="filter.value"
                            :options='[
                                {
                                    value: "",
                                    text: "\u00a0"
                                },
                                {
                                    value: "yes",
                                    text: "Есть ответ"
                                },
                                {
                                    value: "no",
                                    text: "Нет ответа"
                                },
                            ]'/>
                    </v-th>
                </v-tr>
            </template>
            <template v-slot:row="{ item, index }">
                <v-tr :class="['hover', 'pointer']" @click="(row, event) => handleRowClick(event, row, item)">
                    <v-td name="created_at" highlight="*" width="85">
                        {{ item.created_at | formatDate }}
                    </v-td>
                    <v-td name="lastAnswerDate" highlight="*" width="80">
                        <span v-if="item.answers.length > 0">
                                  {{ getLastComment(item).created_at | formatDate }}
                        </span>
                    </v-td>
                    <v-td name="intervieweeName" width="120">
                        <div v-if="item.interviewee_type ==='CLINIC'" class="text-ellipsis">
                            {{currentUser.role==='clinics' ? 'Клинике' : item.interviewee.name }}
                        </div>
                        <div v-else>
                            {{ shortName(item.interviewee.name) }}
                        </div>
                    </v-td>
                    <v-td name="author_name" align="center" width="130">
                            {{item.author_name === '' ? 'Анонимно' : shortName(item.author_name)}}
                    </v-td>
                    <v-td name="info">
                        <div class="commentTextElipsis">
                                {{item.text}}
                        </div>
                        <div v-if="item.answers.length > 0" class="lastReply">
                            <div v-if="item.answers.length > 1">
                                <small>{{ item.answers.length -1 | pluralize('', 'Скрыт еще $ ответ', 'Скрыто еще $ ответа', 'Скрыто еще $ ответов') }}</small>
                            </div>
                            <div>
                                <b>{{ authorTypes[getLastComment(item).author_type]}}:</b>
                                {{ getLastComment(item).text }}
                            </div>

                        </div>
                    </v-td>
                </v-tr>
            </template>
        </v-table>
    </main>
</template>

<script>
import DirectQuestionAnswersDialog from "./DirectQuestionAnswersDialog";
import {mapState} from "vuex";
export default {
    components: {
        DirectQuestionAnswersDialog
    },
    data: function () {
        return {
            authorTypes:{
                NETWORK: 'Ответ сети',
                CLINIC: 'Ответ клиники',
                DOCTOR: 'Ответ врача',
                PATIENT: 'Ответ пациента'
            }
        };
    },
    computed: {
        ...mapState({
            currentUser: state => state.currentUser,
        }),
    },
    methods: {
        getLastComment (item){
            return item.answers.reduce((prev, current) => (+prev.id > +current.id) ? prev : current)
        },
        handleRowClick (event, row, item) {
            row.startLoadingAnimation();
            return this.$refs.directQuestionAnswersDialog.show(item)
                .then(() => row.stopLoadingAnimation())
                .catch(() => row.stopLoadingAnimation());
        },
        shortName (fio) {
            let fioArr = fio.split(' ').filter((word) => word !== '');
            if (fioArr.length === 3){
                return fioArr[0] + ' ' + fioArr[1][0] + '. ' + fioArr[2][0] + '.';
            }
            if (fioArr.length == 2){
                return fioArr[0] + ' ' + fioArr[1][0] + '. ';
            }
            return fio;
        },
    }
}
</script>

<style lang="scss">
.lastReply {
    padding: 5px;
    margin-top: 5px;
    border-top: solid 1px rgba(0, 0, 0, 0.2);
    background-color: rgba(0, 0, 0, 0.05);
}

.commentTextElipsis {
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 16;
    -webkit-box-orient: vertical;
}
</style>
